import {
  Card,
  CardContent,
  Container,
} from "@mui/material";

import AssignmentRuleManager from "./AssignmentRuleManager";

const TabAssignmentRules = () => {
  return (
    <Container maxWidth={false} sx={{ mt: 4, mb: 4 }}>
      <Card>
        <CardContent>
          <AssignmentRuleManager />
        </CardContent>
      </Card>
    </Container>
  );
};

export default TabAssignmentRules;
